module.exports = __webpack_public_path__ + "img/img28.2d79623f.svg";